import { AlertCircle } from 'lucide-react';

import { ValidationError, formatZodErrors } from '@/utils/types/validation';

interface ValidationErrorDisplayProps {
  error: ValidationError;
  caseId: string;
}

export function ValidationErrorDisplay({ error, caseId }: ValidationErrorDisplayProps) {
  const errors = formatZodErrors(error.zodError);

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="w-full max-w-2xl rounded-xl border-2 border-red-200 bg-red-50 p-6 shadow-lg">
        <div className="flex items-start gap-4">
          <AlertCircle className="mt-1 h-8 w-8 flex-shrink-0 text-red-500" />
          <div className="flex-1">
            <h2 className="mb-2 font-heading text-2xl text-red-900">Configuration invalide</h2>
            <p className="mb-4 text-red-700">
              Le cas <strong>{caseId}</strong> contient des erreurs de configuration :
            </p>
            <div className="rounded-lg border border-red-300 bg-white p-4">
              <ul className="space-y-2 font-mono text-sm text-red-800">
                {errors.map((err, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <span className="font-bold text-red-500">•</span>
                    <span>{err}</span>
                  </li>
                ))}
              </ul>
            </div>
            <p className="mt-4 text-sm text-red-600">
              Veuillez mettre à jour le fichier JSON sur S3 pour corriger ces erreurs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
